import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import {
  EmptyState,
  Loading,
  ModalConfirm,
  NoResults,
  SpacingVertical,
  ToastContainer,
  Tooltip
} from 'mailup-web-components'

import emptyStateImage from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-campaign.svg'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import Header from './componets/Header'
import Search from './componets/Search'
import Table from './componets/Table'
import {
  deleteCampaignListCallback,
  getCampaignListCallback,
  initCampaignListCallback,
  resetCampaignListCallback
} from './recoil/callbacks/callbacks'
import { modalDeleteCampaignState } from './recoil/state/modals'
import { pageState, resultsState, searchState } from './recoil/state/page'

import { useHistory } from 'react-router-dom'

const ContentsCampaignList = () => {
  const intl = useIntl()
  const { loading, loaded, error, severity, isEmptyState, isNotResult } =
    useRecoilValue(pageState)
  const initCampaignList = useRecoilCallback(initCampaignListCallback, [])
  const getCampaignList = useRecoilCallback(getCampaignListCallback, [])
  const deleteCampaignList = useRecoilCallback(deleteCampaignListCallback, [])
  const resetCampaignList = useRecoilCallback(resetCampaignListCallback, [])
  const { pageNumber, pageSize } = useRecoilValue(searchState)
  const { totalItems } = useRecoilValue(resultsState)
  const history = useHistory()

  const [{ show, idCampaign, idMessage }, setModalDeleteCampaignState] =
    useRecoilState(modalDeleteCampaignState)

  useEffect(() => {
    return () => {
      resetCampaignList()
    }
  }, [])

  useEffect(() => {
    if (!loaded) {
      initCampaignList().then((e) => {
        getCampaignList({})
      })
    }
  }, [loaded])

  const reloadPage = () => {
    resetCampaignList()
  }

  const confirmDelete = () => {
    deleteCampaignList(idCampaign, idMessage).then((e) => {
      if (e) {
        if (pageNumber > 1) {
          const r = totalItems % pageSize
          if (r === 1) {
            getCampaignList({ pageNumber: pageNumber - 1 })
          }
        } else {
          getCampaignList({})
        }
      }
    })
  }

  const closeModalDelete = () => {
    setModalDeleteCampaignState((prev) => ({
      ...prev,
      show: false,
      idCampaign: 0,
      idMessage: 0
    }))
  }

  const onClickNewCampaign = () => {
    history.push('/automation/contentsCampaign/0/0')
  }

  return (
    <>
      <Header />
      <Tooltip />
      <Loading open={loading} />
      <ToastContainer />

      <ModalConfirm
        show={show}
        title={intl.formatMessage({
          id: 'Load.ModalConfermeDelete.Title'
        })}
        message={intl.formatMessage({
          id: 'Load.ModalConfermeDelete.Description'
        })}
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        onClickCancel={closeModalDelete}
        onClickConfirm={confirmDelete}
        variant='delete'
      />

      <PageContainer className='c-dynamiccontentlist'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={reloadPage}
        />

        {!error &&
          loaded &&
          (isEmptyState ? (
            <EmptyState
              thumbSrc={emptyStateImage}
              title={intl.formatMessage({
                id: 'Load.ContentsCampaignList.EmptyStateTitle'
              })}
              description={intl.formatMessage({
                id: 'Load.ContentsCampaignList.EmptyStateDescr'
              })}
              buttonText={intl.formatMessage({
                id: 'Load.ContentsCampaignList.Create'
              })}
              onClickButton={onClickNewCampaign}
            />
          ) : (
            <>
              <Search />
              <SpacingVertical />
              {!isNotResult && <Table />}
              {isNotResult && (
                <NoResults
                  text={intl.formatMessage({
                    id: 'Load.Common.noResultsTitle'
                  })}
                />
              )}
            </>
          ))}
      </PageContainer>
    </>
  )
}

export default ContentsCampaignList
